import { atom } from 'recoil';

export const meetingConnectionState = atom({
    key: 'meetingConnectionState',
    default: {
        token: null,        // LiveKit JWT token
        url: null,          // LiveKit connection URL
        room: null,         // Room name
        meetingId: null,    // Meeting ID
        live_token: null    // Socket.IO authentication token
    }
});